import { render, staticRenderFns } from "./Leiloeiros.vue?vue&type=template&id=03a2300c"
import script from "./Leiloeiros.vue?vue&type=script&lang=js"
export * from "./Leiloeiros.vue?vue&type=script&lang=js"
import style0 from "./Leiloeiros.vue?vue&type=style&index=0&id=03a2300c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports